import React, {useState, useEffect} from 'react';
import {
	ContenedorSubtituloPequeño, ContenedorSubtitulo, Subtitulo, Descripcion, Lista, ElementoLista, ContenedorFiltros,Contenedor, Formulario,
	Input, ContenedorBoton,Btn, BotonAccion, ContenedorLista, ContenedorInputConIcono,ContenedorItinerario,ElementoListaSimple, ContenedorInputconLabel
} from '../elementos/ElementosDeFormulario';
import { ReactComponent as IconoEstado } from '.././imagenes/estado.svg';
import { ReactComponent as IconoPasajero } from '.././imagenes/pasajero.svg';
import Iconotipo from '../elementos/IconoItinerario';
import Alerta from './../elementos/Alerta';
import { useAuth } from './../contextos/AuthContext';
import {format} from 'date-fns';
import es from "date-fns/locale/es";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faHashtag,faPhone,faEnvelope,faUser, faToggleOn,faAddressCard,faClock,faCar,faComment,faTrailer, faLocationCrosshairs} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';



const FormularioDetalleItinerario = ({id, viaje, itinerario, cambiarItinerario, listadoPasajeros, cambiarListadoPasajeros}) => {
    const {usuario} = useAuth();
    const navigate = useNavigate();
    const [fechahoraviaje, cambiarFechahoraviaje] = useState (new Date());
    const [fecha_hora_creacion, cambiarfecha_hora_creacion] = useState (new Date());
    const [cliente, cambiarCliente] = useState ('Seleccione Cliente');
    const [estado, cambiarEstado] = useState ('Programado');
    const [movil, CambiarMovil] = useState({numero:"Movil"});
    const [comentarios, CambiarComentarios] = useState('');
    const [ordenado, CambiarOrdenado] = useState('');
    const [alerta, cambiarAlerta] = useState({});
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const[fechaFormateada,cambiafechaFormateada] = useState();

    const formatearFecha2 = (fecha = new Date()) => {
        return format((fecha), "dd '-' MMM'", {locale: es});
        }

    const formatearFecha = (fecha = new Date()) => {
        if (fecha !== ''){return format((fecha), "HH:mm", {locale: es});} 
        
    }

    const servicio = (viaje1) => {
        if ((viaje1.empresa === 'Metro' || viaje1.empresa === 'METRO') && viaje.folio!=='undefined')
        {return (`Servicio ${viaje1.empresa} Folio ${viaje.folio}`)} 
        else 
        {return (`Servicio ${viaje1.empresa} ${viaje.comentarios}`)} 
    }

    const pasajero = (pasajero1) => {
        if (pasajero1.fechahoraviajep !== '')
        {return (`${formatearFecha(pasajero1.fechahoraviajep)} Hrs. Tel: ${pasajero1.telefono} Nombre: ${pasajero1.nombre}`)} 
        else 
        {return (`Tel: ${pasajero1.telefono} Nombre: ${pasajero1.nombre}`)} 
    }

    const pasajerodet = (pasajero1) => {
        if (pasajero1.cliente === 'undefined' || pasajero1.cliente === '' || !pasajero1.hasOwnProperty("cliente"))
        {
               console.log("Sin Cliente")
        }
        else 
        {
            
        if (pasajero1.hasOwnProperty("cliente"))  {
            
            if ((pasajero1.cliente === ('Mutual Agustinas ')) || 
            (pasajero1.cliente === ('Mutual De Seguridad')) || 
            (pasajero1.cliente === ('Mutual Enea')) || 
            (pasajero1.cliente === ('Mutual La Florida')) || 
            (pasajero1.cliente === ('Mutual Lo Espejo')) || 
            (pasajero1.cliente === ('Mutual Maipu')) || 
            (pasajero1.cliente === ('Mutual Paine')) || 
            (pasajero1.cliente === ('Mutual Providencia')) || 
            (pasajero1.cliente === ('Mutual Puente Alto')) || 
            (pasajero1.cliente === ('Mutual Quilicura')) || 
            (pasajero1.cliente === ('MUTUAL SAM615')) || 
            (pasajero1.cliente === ('Mutual San Bernardo')) || 
            (pasajero1.cliente === ('Mutual Talagante'))
            )
            {if (pasajero1.comentariop === 'undefined' || pasajero1.comentariop === '')
                    {return (`RUT: ${pasajero1.rfc}`)}
                    else
                    {return (`RUT: ${pasajero1.rfc} Comentarios: ${pasajero1.comentariop}`)}
            }    
            else 
            {if (pasajero1.rfc === 'undefined' || pasajero1.rfc === '' )
                    {if (pasajero1.comentariop === 'undefined' || pasajero1.comentariop === '')
                        {
                            return (`Sin Comentarios`)
                        }
                    else{
                        return (`Comentarios: ${pasajero1.comentariop}`)
                    }
            }
            else
            {if (pasajero1.comentariop === 'undefined' || pasajero1.comentariop === '' )
                    {
                        return (`Folio / CC : ${pasajero1.rfc}`)
                    }
                    else{
                        return (`Folio / CC : ${pasajero1.rfc} Comentarios: ${pasajero1.comentariop}`)
                    }
            }
            } 

        } else {
            if (pasajero1.rfc === 'undefined' || pasajero1.rfc === '' )
                    {if (pasajero1.comentariop === 'undefined' || pasajero1.comentariop === '')
                        {
                            return (`Sin Comentarios`)
                        }
                    else{
                        return (`Comentarios: ${pasajero1.comentariop}`)
                    }
            }
            else
            {if (pasajero1.comentariop === 'undefined' || pasajero1.comentariop === '' )
                    {
                        return (`Folio / CC : ${pasajero1.rfc}`)
                    }
                    else{
                        return (`Folio / CC : ${pasajero1.rfc} Comentarios: ${pasajero1.comentariop}`)
                    }
            }
        }
            
        }
        }
      
    useEffect (()=>{
    viaje.empresa && cambiarCliente(viaje.empresa);
    viaje.numero_m && CambiarMovil({
        numero:  viaje.numero_m,
        color: viaje.color_m,
        nombre: viaje.nombre_m,
        patente: viaje.patente_m,
        telefono: viaje.telefono_m
    });
    viaje.fecha_hora_programada && cambiarFechahoraviaje(new Date(viaje.fecha_hora_programada));
    viaje.itinerario && cambiarItinerario(Object.keys(viaje.itinerario).map(function (key) {return {id : key, ...viaje.itinerario[key]};}))
    viaje.pasajeros && cambiarListadoPasajeros(Object.keys(viaje.pasajeros).map(function (key) {return {id : key, ...viaje.pasajeros[key]};}))  
    viaje.estado && cambiarEstado(viaje.estado);
    viaje.fecha_hora_creacion && cambiarfecha_hora_creacion(new Date(viaje.fecha_hora_creacion));
    },[viaje]);

    useEffect (()=>{    
        if (viaje.fecha_hora_programada !== 'Ingrese Fecha y hora de Viaje')
        {cambiafechaFormateada(formatearFecha(viaje.fecha_hora_programada))}
        else
        {cambiafechaFormateada(viaje.fecha_hora_programada)}
    },[fechahoraviaje]);



    return (  
                
                    <Formulario >
                        <Contenedor>
                        <main>   

                        <ContenedorSubtitulo>
                            <Subtitulo>&nbsp;&nbsp;Itinerario de Viaje &nbsp;&nbsp;&nbsp;</Subtitulo>   
                        </ContenedorSubtitulo>
                        
                        <Lista>
                        {itinerario.map((pasajerol, index) =>{
                                let muestrahora = true
                                if(pasajerol.hasOwnProperty("comentariop") || pasajerol.hasOwnProperty("fechahoraviajep"))
                                {if(pasajerol.comentariop !=='' || pasajerol.fechahoraviajep !==''){muestrahora = false}};
                                

                                return(
                                <ElementoListaSimple key={pasajerol.id}>
                                <ContenedorItinerario>
                                <ContenedorInputconLabel><p>Orden</p> <Input name="orden_p" type="text" placeholder="Orden" value={index+1} disabled = {true}/></ContenedorInputconLabel>
                                <ContenedorInputconLabel><p>Nombre</p>  <Input name="telefono_p" type="text" placeholder="Telefono Pasajero" value={pasajerol.nombre} disabled = {true}/> </ContenedorInputconLabel>
                                <ContenedorInputconLabel><p>{pasajerol.tipo}</p> <Input name="fcr" type="text" placeholder="Centro de Costo" value={pasajerol.direccion} disabled = {true}/> </ContenedorInputconLabel>
                                </ContenedorItinerario>
                                <div hidden={muestrahora}>
                                <ContenedorItinerario >
                                    <ContenedorInputConIcono></ContenedorInputConIcono>
                                    <ContenedorInputconLabel><p>Hora Programada</p> <Input name="fechahoraviajep" type="text" placeholder="--" value={formatearFecha(pasajerol.fechahoraviajep)} disabled = {true}/> </ContenedorInputconLabel>
                                    <ContenedorInputconLabel><p>Comentario</p><Input name="comentariop" type="text" placeholder="--" value={pasajerol.comentariop} disabled = {true}/> </ContenedorInputconLabel>
                                </ContenedorItinerario>

                                </div>

                                </ElementoListaSimple>
                                )
                        })}
                        </Lista> 
                        </main>
{formatearFecha2(viaje.fecha_hora_programada)}&nbsp;&nbsp;{formatearFecha(viaje.fecha_hora_programada)} Hrs.<br/>
{servicio(viaje)}<br/>
----------------------------------------<br/>
PASAJEROS<br/>
                        {listadoPasajeros.map((pasajerol, index) =>{
                                let muestrahora = true
                                if(pasajerol.hasOwnProperty("comentariop") || pasajerol.hasOwnProperty("fechahoraviajep"))
                                {if(pasajerol.comentariop !=='' || pasajerol.fechahoraviajep !==''){muestrahora = false}};
                                return(

<>
----------------------------------------<br/>
{pasajero(pasajerol)}<br/>
Origen : {pasajerol.direccion_o}<br/>
Destino :  {pasajerol.direccion_d}<br/>
{pasajerodet(pasajerol)}<br/>
</>
)
                        })}
----------------------------------------<br/>                      
RUTA<br/>

 
{itinerario.map((pasajerol, index) =>{
                                let muestrahora = true
                                if(pasajerol.hasOwnProperty("comentariop") || pasajerol.hasOwnProperty("fechahoraviajep"))
                                {if(pasajerol.comentariop !=='' || pasajerol.fechahoraviajep !==''){muestrahora = false}};
                                return(
<>
----------------------------------------<br/>
{index+1} {pasajerol.nombre}<br/>
{pasajerol.tipo} {pasajerol.direccion}<br/>
</>
)
                        })}                        
----------------------------------------<br/> 
                        </Contenedor>
                        <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={cambiarEstadoAlerta}
            />
                    </Formulario>
    );
}
 
export default FormularioDetalleItinerario;